import { api } from "./api";

import * as apiLink from "../lib/constants/apiLink";
// Developers can override this with an env.local file
const baseUrl = apiLink.BASE_API_URL;

/**
 * Function for getting virtual payment data from backend api.
 * @param {string} token Login token.
 * @param {object} body Request body.
 */
export const getVirtualTerminal = (token, body) => {
  return api(baseUrl, token).post(apiLink.VIRTUAL_TERMINAL_PAYMENT,body);
};

/**
 * Function for getting payment methods data from backend api.
 * @param {string} token Login token.
 * @param {object} body Request body.
 */
export const getPaymentMethods = (token, body) => {
  return api(baseUrl, token).post(apiLink.GET_PAYMENT_METHODS,body);
}

/**
 * Function for getting tx diagnose data from backend api.
 * @param {string} token Login token.
 * @param {object} body Request body.
 */
export const getTXDiagnose = (token, body) => {
  return api(baseUrl, token).post(apiLink.GET_TX_DIAGNOSE,body);
}
